import { ActionButtonProps, Box, ColorOptions, Form, Icon, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useNavigation } from '@react-navigation/core'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Colors } from '../../util/util'
import { Header } from './Header'
import { CreaateCampaignForm } from './formData'

const CreateCampaign: FC = ({ route }: any) => {
  const id = route?.params?.id
  const isDuplicate = route?.params?.isDuplicate

  const {
    updateCampaign,
    getInstruments,
    getCampaignDetailsWithId,
    canCreateCampaigns,
    updateRuleConfigError,
    count,
    setCustomToast,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    updateCampaign: store.campaigns.createCampaign,
    allPaymentModes: store.campaigns.paymentModes,
    updatePaymentModeSelection: store.campaigns.updatePaymentModeSelection,
    getInstruments: store.campaigns.getInstruments,
    getCampaignDetailsWithId: store.campaigns.getCampaignDetailsWithId,
    setError: store?.response?.setMessage,
    canCreateCampaigns: store.userManagement.canCreateCampaigns(),
    updateRuleConfigError: store.campaigns.updateRuleConfigError,
    ruleConfigErrors: store.campaigns.config.ruleConfigErrors,
    count: store.campaigns.getAttributesCount(),
    setCustomToast: store.response.setCustomToast,
  }))

  const [updateCampaignApi, { state }] = useLazyApiData(updateCampaign)

  const formActionButtonRef = useRef<ActionButtonProps>()
  const formRef = useRef(null)

  const { navigate } = useNavigation()
  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      if (state === 'fulfilled') {
        setCustomToast({
          message: !!id && id?.length > 0 ? 'Campaign updated successfully' : 'Campaign created successfully',
          color: 'GREEN',
        })
      }
      navigate(Routes.CAMPAIGNS)
    }
  }, [state])

  const renderActionButtons = (props: ActionButtonProps) => {
    formActionButtonRef.current = props
    return <></>
  }

  const amountRegex = new RegExp(/^\d+(\.\d{1,2})?$/)
  let isValid = true
  const validate = (ruleConfig: any) => {
    isValid = true
    if (!ruleConfig.txnAmountKey) {
      updateRuleConfigError('txnAmountKey', 'Required')
      isValid = false
    }
    if (ruleConfig?.txnAmountKey !== 'Range' && !ruleConfig?.txnAmount) {
      updateRuleConfigError('txnAmount', 'Required')
      updateRuleConfigError('maxAmount', null)
      updateRuleConfigError('minAmount', null)
      isValid = false
    }
    if (ruleConfig?.txnAmountKey === 'Range' && !ruleConfig?.maxAmount) {
      updateRuleConfigError('maxAmount', 'Required')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }
    if (ruleConfig?.txnAmountKey === 'Range' && !ruleConfig?.minAmount) {
      updateRuleConfigError('minAmount', 'Required')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }
    if (ruleConfig?.txnAmountKey !== 'Range' && !!ruleConfig.txnAmount && !amountRegex.test(ruleConfig.txnAmount)) {
      updateRuleConfigError('txnAmount', 'Invalid amount.')
      updateRuleConfigError('maxAmount', null)
      updateRuleConfigError('minAmount', null)
      isValid = false
    }
    if (ruleConfig?.txnAmountKey === 'Range' && !!ruleConfig.maxAmount && !amountRegex.test(ruleConfig.maxAmount)) {
      updateRuleConfigError('maxAmount', 'Invalid amount.')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }

    if (ruleConfig?.txnAmountKey === 'Range' && !!ruleConfig.minAmount && !amountRegex.test(ruleConfig.minAmount)) {
      updateRuleConfigError('minAmount', 'Invalid amounttt.')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }
    if (
      ruleConfig?.txnAmountKey === 'Range' &&
      !!ruleConfig.minAmount &&
      !!ruleConfig?.maxAmount &&
      Number(ruleConfig.minAmount) > Number(ruleConfig.maxAmount)
    ) {
      updateRuleConfigError('maxAmount', 'Invalid amount.')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }
    if (
      ruleConfig?.txnAmountKey === 'Range' &&
      !!ruleConfig.minAmount &&
      !!ruleConfig?.maxAmount &&
      Number(ruleConfig.minAmount) > Number(ruleConfig.maxAmount)
    ) {
      updateRuleConfigError('minAmount', 'Min Amount cant be greater than Max Amount')
      updateRuleConfigError('txnAmount', null)
      isValid = false
    }
    if (!ruleConfig.paymentMode) {
      updateRuleConfigError('paymentMode', 'Required')
      isValid = false
    }
    if (
      ruleConfig?.paymentMode !== 'No Cost EMI' &&
      ruleConfig?.paymentMode !== 'Card' &&
      (!ruleConfig.paymentInstrument || ruleConfig.paymentInstrument.length === 0)
    ) {
      updateRuleConfigError('paymentInstrument', 'Required')
      isValid = false
    }
    if (ruleConfig.paymentMode === 'Card' || ruleConfig.paymentMode === 'No Cost EMI') {
      if (!ruleConfig.bin || ruleConfig.bin.length === 0) {
        updateRuleConfigError('bin', 'Required')
        isValid = false
      } else if (ruleConfig?.bin?.some((item) => item?.length > 8)) {
        updateRuleConfigError('bin', 'Bin length should not more than 8')
        isValid = false
      }
    }
    for (let i = 1; i <= count; i++) {
      if (ruleConfig?.[`isIncludedIdChecked${i}`] && !ruleConfig[`txnAttributeKey${i}`]) {
        updateRuleConfigError([`txnAttributeKey${i}`], 'Required')
        isValid = false
      }
      if (
        ruleConfig?.[`isIncludedIdChecked${i}`] &&
        (!ruleConfig[`txnAttributeIncluded${i}`] || ruleConfig[`txnAttributeIncluded${i}`].length === 0)
      ) {
        updateRuleConfigError([`txnAttributeIncluded${i}`], 'Required')
        isValid = false
      }
      if (
        ruleConfig[`isExcludedIdChecked${i}`] &&
        (!ruleConfig[`txnAttributeExcluded${i}`] || ruleConfig[`txnAttributeExcluded${i}`].length === 0)
      ) {
        updateRuleConfigError([`txnAttributeExcluded${i}`], 'Required')
        isValid = false
      }
    }
    for (let i = 0; i < ruleConfig?.tenure?.length; i++) {
      if (!ruleConfig?.tenure?.[i]) {
        updateRuleConfigError('emiBankName', 'Required')
        isValid = false
      }
      if (!ruleConfig?.roi?.[i]) {
        updateRuleConfigError('emiBankName', 'Required')
        isValid = false
      }
      if (!ruleConfig?.tenure?.[i] && !ruleConfig?.roi?.[i]) {
        updateRuleConfigError('emiBankName', null)
        updateRuleConfigError('emiBankName', null)
        isValid = true
      }
    }
    if (ruleConfig?.paymentMode === 'No Cost EMI' && (!ruleConfig.tenure || ruleConfig?.tenure?.length === 0)) {
      updateRuleConfigError('emiBankName', 'Required')
      isValid = false
    }
    if (ruleConfig?.paymentMode === 'No Cost EMI' && (!ruleConfig.roi || ruleConfig?.roi?.length === 0)) {
      updateRuleConfigError('emiBankName', 'Required')
      isValid = false
    }
    if (
      ruleConfig?.paymentMode === 'No Cost EMI' &&
      (ruleConfig?.roi?.length !== ruleConfig?.tenure?.length ||
        ruleConfig?.emiBankName?.length !== ruleConfig?.tenure?.length ||
        ruleConfig?.roi?.length !== ruleConfig?.emiBankName?.length)
    ) {
      updateRuleConfigError('emiBankName', 'Invalid Input')
      isValid = false
    }
  }
  const onProceed = () => {
    formActionButtonRef.current?.defaultActionButtonOnSubmit()
    const values = formActionButtonRef.current?.values
    const ruleConfig: any = values.ruleConfig
    validate(ruleConfig)
    if (formActionButtonRef.current?.isCurrentFormValid) {
      if (isValid) {
        updateCampaignApi(formActionButtonRef.current?.values, id, isDuplicate)
      }
    }
  }

  const rupeeComp = () => {
    return <Text fontSize={12} fontFamily={'jiotype-medium'} color={Colors.FONT_COLOR as ColorOptions} title={'In ₹'} />
  }

  const lockComp = () => {
    if (isEmpty(id)) {
      return null
    }
    return <Icon id={'LOCK'} size={12} color={'TEXT_PRIMARY' as ColorOptions} />
  }

  const percentageIcon = () => {
    return <Text title={'%'} color={'BLACK_21'} fontFamily={'jiotype-bold'} />
  }

  const rightComp = () => {
    return <Icon id={'LOCK'} size={12} color={'TEXT_PRIMARY' as ColorOptions} />
  }
  const data = getCampaignDetailsWithId(id)
  const [paymentMode, updatePaymentMode] = useState(data?.ruleConfig?.paymentMode ?? '')

  const getDate = (date: any) => (new Date(date) >= new Date() ? date : undefined)
  const getInitialValForDedupe = useCallback(() => {
    return { ...data, campaignId: '', startDate: getDate(data?.startDate), endDate: getDate(data?.endDate) }
  }, [data])

  return (
    <Box
      backgroundColor="WHITE"
      marginHorizontal={16}
      // p={16}
      f={1}
      borderRadius={8}
      display="flex"
      justify="space-between"
      shadowRadius={3}
      shadowColor={'#0000001F' as ColorOptions}
      zIndex={1}>
      <Header
        title={id ? 'Edit Campaign' : 'New Campaign'}
        okTitle={isDuplicate ? 'Duplicate' : id ? 'Update Campaign' : 'Publish Now'}
        cancelTitle={id ? 'Cancel' : ''}
        canCreateCampaigns={canCreateCampaigns}
        onProceed={onProceed}
        apiState={state === 'pending'}
      />
      <Box f={1} pv={40} overflow="auto" flexWrap="wrap" ph={80}>
        <Form
          ref={formRef}
          container={DefaultFormContainer}
          formData={CreaateCampaignForm(
            getInstruments,
            percentageIcon(),
            rupeeComp(),
            lockComp(),
            id,
            rightComp(),
            (val) => updatePaymentMode(val),
            paymentMode,
            isDuplicate,
          )}
          initialValues={
            isDuplicate ? JSON.parse(JSON.stringify(getInitialValForDedupe())) : id ? JSON.parse(JSON.stringify(getCampaignDetailsWithId(id))) : {}
          }
          actionButtons={renderActionButtons}
        />
      </Box>
    </Box>
  )
}

export default CreateCampaign
